var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 971.1 300",
    enableBackground: "new 0 0 971.1 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.6823,
    y1: 388.6703,
    x2: 767.6509,
    y2: 1040.6749,
    gradientTransform: "matrix(1 0 0 -1 0 845.2814)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001211"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00818A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M572.4,185.6h1l13.8,66c5.2,24.6,19.3,40,44.5,40c22.2,0,35.5-11.2,47.4-31.1l61.5-102.8l25.5,94.8 c7.6,27.9,22.7,39.1,45,39.1c20.3,0,35.5-11.7,46.4-31.1L964,70.2c4.8-8.9,7.1-17.3,7.1-25.1c0-22.3-17.6-39.5-43.1-39.5 c-20.8,0-37.9,12.1-49.3,33.9L827.1,139l-25-98.1c-5.9-21.5-18.2-35.5-42.8-35.5c-16.2,0-31.7,4.7-46.4,31.6l-53.9,101.8L641,42.2 c-4.9-25.5-22.8-36.7-44.7-36.7c-25,0-44.1,17.7-44.1,43.3c0,2.8,0,4.7,1,11.2l2.4,14.9h-1C530.6,29.3,484.6,0,425,0 c-59.1,0-107.9,31.6-130.1,74.9h-1l3.3-21c0.5-3.3,1-7.9,1-10.3C298.2,18.5,281.6,5,258,5c-20.3,0-38.3,11.7-44.1,39.1l-18.9,94.8 L124.9,30.7c-12.2-19.1-25-25.2-40.6-25.2c-19.3,0-37.4,9.8-42.6,34.9L1.4,234.8C0.5,240.4,0,246,0,250.2 c0,26.9,17.1,41.4,40.3,41.4c18.9,0,40.3-12.1,45.5-38.1l19.3-93.4l64.8,103.7c9.5,15.4,21.7,27.9,42.6,27.9 c24.1,0,38.8-13.5,44.1-36.7l14.7-69.3h1c12.4,66,67.7,114.4,147.2,114.4C496.6,300,557.7,248.8,572.4,185.6z M423.1,218 c-37.9,0-67.7-30.7-67.7-67.9c0-39.1,29.8-67.9,67.7-67.9c38.3,0,68.1,30.2,68.1,67.9S461.5,218,423.1,218z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowLogo);
export default __webpack_public_path__ + "static/media/NowLogo.57fd8c5d098b696d517b55164ae497bb.svg";
export { ForwardRef as ReactComponent };